import React from 'react';
import Header from './Header';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSessionExpiration } from '../../hooks/useSessionExpiration';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const { sessionExpired, message, dismiss } = useSessionExpiration();

    return (
        <div className="d-flex flex-column min-vh-100 layout-root">
            <Header />
            <div className="d-flex flex-grow-1">
                <main className="flex-grow-1" style={{ padding: 0 }}>
                    {children}
                </main>
            </div>

            {/* Global session-expired toast */}
            <Snackbar
                open={sessionExpired}
                autoHideDuration={10000}
                onClose={dismiss}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={dismiss} severity="warning" variant="filled" sx={{ width: '100%' }}>
                    {message || 'Session expired – please sign in again.'}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Layout;